import type { IUiVisibility } from '@shore/types';

export const defaultUiVisibility: IUiVisibility = {
  employee: {},
  user_profile: { company: 'active', settings: 'active' },
  user_profile_page: {},
  reportings: {},
  services: {},
};

interface HasUiVisibility {
  ui_visibility?: IUiVisibility;
}

export const getUiVisibility = (
  response: HasUiVisibility | null | undefined
): IUiVisibility => {
  const visibility = response?.ui_visibility ?? null;

  if (
    visibility !== null &&
    visibility.user_profile?.settings &&
    visibility.user_profile?.company
  ) {
    return visibility;
  }

  return defaultUiVisibility;
};
